import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcPredictiveNetworks = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5.781 4.723a.75.75 0 1 0 .75 1.3l.399-.23a.75.75 0 0 0-.75-1.3l-.399.23Zm2.627-1.517a.75.75 0 1 0 .75 1.3l.398-.23a.75.75 0 0 0-.75-1.3l-.398.23ZM12 6.615a.75.75 0 0 1-.75-.75v-.46a.75.75 0 0 1 1.5 0v.46a.75.75 0 0 1-.75.75Zm0 3.08a.75.75 0 0 1-.75-.75v-.46a.75.75 0 0 1 1.5 0v.46a.75.75 0 0 1-.75.75Zm1.995 3.457a.75.75 0 0 1 1.025-.275l.398.23a.75.75 0 0 1-.75 1.3l-.398-.23a.75.75 0 0 1-.275-1.025Zm2.667 1.54a.75.75 0 0 1 1.025-.275l.398.23a.75.75 0 1 1-.75 1.3l-.398-.23a.75.75 0 0 1-.275-1.025Zm.275-6.409a.75.75 0 0 0 .75 1.299l.398-.23a.75.75 0 0 0-.75-1.299l-.398.23Zm3.723 1.22a.75.75 0 0 1 .75.75v.46a.75.75 0 0 1-1.5 0v-.46a.75.75 0 0 1 .75-.75Zm0 3.033a.75.75 0 0 1 .75.75v.46a.75.75 0 0 1-1.5 0v-.46a.75.75 0 0 1 .75-.75Zm-2.841-8.043a.75.75 0 1 0-.75 1.3l.398.23a.75.75 0 1 0 .75-1.3l-.398-.23Zm-2.627-1.516c-.316-.182-.774-.06-1.025.274-.163.384-.04.843.275 1.025l.398.23a.75.75 0 0 0 .75-1.3l-.398-.23Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.965 6.35a.75.75 0 0 1 .75 0L12 11.134l2.44-1.409a.75.75 0 1 1 .75 1.3l-2.44 1.408v8.268l4.504-2.6a.75.75 0 0 1 .75 1.299l-5.629 3.25a.75.75 0 0 1-.75 0l-8.66-5A.75.75 0 0 1 2.59 17V7a.75.75 0 0 1 .375-.65Zm8.285 14.351v-7.402L4.84 17l6.41 3.701Zm-7.16-5V8.299L10.5 12l-6.41 3.701Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.5 2a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm8.66 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-1.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcPredictiveNetworks");

export { IcPredictiveNetworks };
//# sourceMappingURL=ic-predictive-networks.js.map
